<template>
<div>
  <nav id="header" v-if="$store.state.isLoggedIn" class="navbar navbar-expand navbar-dark bg-dark">
    <div class="row mr-auto">
      <a class="navbar-brand" href="#">
        <img src="/images/dpg-logo-horizontal-large.png" height="60" alt="DPG Media"/>
      </a>
      <ul class="navbar-nav align-items-center">
        <li v-if="$store.state.role === 'admin'" class="nav-item">
          <router-link class="nav-link" to="/">Home</router-link>
        </li>
        <li v-if="$store.state.role === 'admin'" class="nav-item">
          <router-link class="nav-link" to="/users">Users</router-link>
        </li>
        <li v-if="$store.state.role === 'admin'" class="nav-item">
          <router-link class="nav-link" to="/properties">Properties</router-link>
        </li>
        <li v-if="$store.state.role === 'admin'" class="nav-item">
          <router-link class="nav-link" to="/keys">API Keys</router-link>
        </li>
        <li class="nav-item">
          <router-link class="nav-link" to="/stories">Stories</router-link>
        </li>
      </ul>
    </div>
    <button type="submit" class="btn btn-default btn-sm" v-on:click.stop.prevent="logout">Logout</button>
  </nav>
  <router-view/>
</div>
</template>
<script>
export default {
  name: 'App',
  methods: {
    logout: function() {
      this.$store.dispatch('logout');
      this.$router.push('/login');
    }
  }
}
</script>
